module.exports = __webpack_public_path__ + "img/forestorytellingtour_main_06.940e3387.jpg";